/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Conversion_FailedInputs */

const en_mobile_conversion_failed = /** @type {(inputs: Mobile_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion failed`)
};

const es_mobile_conversion_failed = /** @type {(inputs: Mobile_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de conversión`)
};

/**
* | output |
* | --- |
* | "Conversion failed" |
*
* @param {Mobile_Conversion_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_conversion_failed = /** @type {((inputs?: Mobile_Conversion_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Conversion_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_conversion_failed(inputs)
	return en_mobile_conversion_failed(inputs)
});